export const isCancelledOrder = statusName => {
  return ['CANCELLED', 'ORDER REQUEST (REJECTED)'].includes(statusName);
};
